var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          name: "token-popup",
          id: "Token-popup",
          transition: "pop-out",
          width: 800,
          adaptive: true,
          maxWidth: 800,
          height: "600",
          scrollable: true
        }
      },
      [
        _vm.step == 1
          ? _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-head" }, [
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close"
                    },
                    on: { click: _vm.close }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "yes-sec" }, [
                  _c("h2", [_vm._v("Purchase Impact Tokens")]),
                  _vm._v(" "),
                  _c("section", [
                    _vm.optionLoader
                      ? _c("div", { staticClass: "loading" }, [_vm._m(0)])
                      : _vm._e(),
                    _vm._v(" "),
                    !this.onlyEditSettings &&
                    _vm.isUserCardAdded &&
                    !_vm.optionLoader
                      ? _c(
                          "div",
                          { staticClass: "form-row token-puchase-row row" },
                          [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("p", [
                                _vm._v("Your Token balance (USD): "),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companySettings.total_outstanding
                                        ? _vm.commafy(
                                            _vm.companySettings
                                              .total_outstanding
                                          )
                                        : "0.00"
                                    ) +
                                      " (" +
                                      _vm._s(
                                        _vm.companySettings.unallocated
                                          ? _vm.commafy(
                                              _vm.companySettings.unallocated
                                            )
                                          : 0
                                      ) +
                                      " available)"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("label", [_vm._v("Top-up amount (USD)")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tokenamt,
                                    expression: "tokenamt"
                                  }
                                ],
                                staticStyle: { width: "100px" },
                                attrs: {
                                  type: "text",
                                  name: "token-amount",
                                  id: "token-amount",
                                  placeholder: "100"
                                },
                                domProps: { value: _vm.tokenamt },
                                on: {
                                  keyup: function($event) {
                                    return _vm.checkNumbersOnly("token-amount")
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.tokenamt = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.surcharge > 0
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "small",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "margin-top": "15px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Please note that " +
                                          _vm._s(_vm.surcharge) +
                                          "% surcharge applies to fund the extra admin, data management and development of engagement tools. Your support helps B1G1’s work to ensure effective impact creation."
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._m(1),
                              _vm._v(" "),
                              _vm.isCharityCountry != false
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "small",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "margin-top": "15px"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            "font-weight": "500",
                                            align: "center"
                                          },
                                          attrs: {
                                            href:
                                              "https://www.b1g1.org/charity-disclosure",
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("Charity Disclosure")]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-md-6",
                                staticStyle: { "padding-left": "50px" }
                              },
                              [
                                _c("aside", [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.billing_period,
                                          expression: "billing_period"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "rd_billing_period",
                                        value: "one-time",
                                        id: "rd-beginning-billing-period"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.billing_period,
                                          "one-time"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.billing_period = "one-time"
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                    One-time purchase"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.billing_period,
                                          expression: "billing_period"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "rd_billing_period",
                                        value: "monthly",
                                        id: "rd-beginning-billing-period"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.billing_period,
                                          "monthly"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.billing_period = "monthly"
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                    Top up this amount every month"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.billing_period === "monthly"
                                    ? _c(
                                        "div",
                                        { staticClass: "sub-options" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.monthly_billing_period,
                                                  expression:
                                                    "monthly_billing_period"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "monthly_billing_period",
                                                value: "beginning",
                                                id:
                                                  "rd-beginning-billing-period"
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.monthly_billing_period,
                                                  "beginning"
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.monthly_billing_period =
                                                    "beginning"
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      Beginning of the month"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.monthly_billing_period,
                                                  expression:
                                                    "monthly_billing_period"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "monthly_billing_period",
                                                value: "middle",
                                                id: "rd-middle-billing-period "
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.monthly_billing_period,
                                                  "middle"
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.monthly_billing_period =
                                                    "middle"
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      Middle of the month"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.monthly_billing_period,
                                                  expression:
                                                    "monthly_billing_period"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "monthly_billing_period",
                                                value: "end",
                                                id: "rd-end-billing-period"
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.monthly_billing_period,
                                                  "end"
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.monthly_billing_period =
                                                    "end"
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              "\n                      End of the month"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("br")
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.billing_period,
                                          expression: "billing_period"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "rd_billing_period",
                                        value: "topup",
                                        id: "token-topup-option"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.billing_period,
                                          "topup"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.billing_period = "topup"
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                    Auto top-up at (USD)  "
                                    ),
                                    _c("span", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.top",
                                          value: {
                                            content:
                                              "Your Token balance will automatically top up when it drops to this amount.",
                                            class: "normal-tooltip"
                                          },
                                          expression:
                                            "{ content: 'Your Token balance will automatically top up when it drops to this amount.', class: 'normal-tooltip' }",
                                          modifiers: { top: true }
                                        }
                                      ],
                                      staticClass:
                                        "fa fa-info-circle fa-lg infopop",
                                      attrs: {
                                        "data-container": "body",
                                        "data-toggle": "popover"
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.topupamt,
                                        expression: "topupamt"
                                      }
                                    ],
                                    staticStyle: { width: "60px" },
                                    attrs: {
                                      type: "text",
                                      name: "topup-token-amount",
                                      id: "topup-token-amount",
                                      placeholder: "20",
                                      min: "1",
                                      max: "1000"
                                    },
                                    domProps: { value: _vm.topupamt },
                                    on: {
                                      keyup: function($event) {
                                        return _vm.checkNumbersOnly(
                                          "topup-token-amount"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.topupamt = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("br")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "b-btn red-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.showConfirmationModal()
                                      }
                                    }
                                  },
                                  [_vm._v("PROCEED")]
                                )
                              ]
                            )
                          ]
                        )
                      : !_vm.optionLoader
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "form-row token-puchase-row row" },
                            [
                              _c("div", { staticClass: "col-md-6" }, [
                                _c("p", [
                                  _vm._v("Your Token balance (USD): "),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companySettings.total_outstanding
                                          ? _vm.commafy(
                                              _vm.companySettings
                                                .total_outstanding
                                            )
                                          : "0.00"
                                      ) +
                                        " (" +
                                        _vm._s(
                                          _vm.companySettings.unallocated
                                            ? _vm.commafy(
                                                _vm.companySettings.unallocated
                                              )
                                            : 0
                                        ) +
                                        " available)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-6",
                                  staticStyle: { "padding-left": "50px" }
                                },
                                [
                                  _c("aside", [
                                    _vm._v(
                                      "Top-up amount (USD)\n                    "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.tokenamt,
                                          expression: "tokenamt"
                                        }
                                      ],
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        type: "text",
                                        name: "token-amount",
                                        id: "token-amount",
                                        placeholder: "100"
                                      },
                                      domProps: { value: _vm.tokenamt },
                                      on: {
                                        keyup: function($event) {
                                          return _vm.checkNumbersOnly(
                                            "token-amount"
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.tokenamt = $event.target.value
                                        }
                                      }
                                    })
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-11" }, [
                                _c("br"),
                                _vm._v(" "),
                                _vm.surcharge > 0
                                  ? _c(
                                      "p",
                                      { staticStyle: { "font-size": "16px" } },
                                      [
                                        _vm._v(
                                          "Please note that " +
                                            _vm._s(_vm.surcharge) +
                                            "% surcharge applies to fund the extra admin, data management and development of engagement tools. Your support helps B1G1’s work to ensure effective impact creation."
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._m(2)
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 text-center" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "b-btn red-btn",
                                      on: {
                                        click: function($event) {
                                          return _vm.showConfirmationModal()
                                        }
                                      }
                                    },
                                    [_vm._v("Purchase Impact Tokens")]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  this.onlyEditSettings
                                    ? _c(
                                        "a",
                                        {
                                          staticStyle: { "font-size": "16px" },
                                          attrs: { href: "/billing-tokens" }
                                        },
                                        [
                                          _vm._v(
                                            "Or update your automatic Token top-up setting"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.step == 2
          ? _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-head" }, [
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close"
                    },
                    on: { click: _vm.close }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "billing-popup" }, [
                  _vm.billing_period === "one-time"
                    ? _c("h2", [_vm._v("Purchase Impact Tokens")])
                    : _c("h2", [_vm._v("Setting up Impact Token billing")]),
                  _vm._v(" "),
                  _vm.billing_period === "one-time"
                    ? _c("p", [
                        _vm._v("You are about to purchase "),
                        _c("b", [
                          _vm._v(
                            "US $" + _vm._s(_vm._f("currency")(_vm.tokenamt))
                          )
                        ]),
                        _vm._v(" worth of Impact Tokens.")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.billing_period === "monthly"
                    ? _c("p", [
                        _vm._v(
                          "You are about to set up an auto monthly top-up of "
                        ),
                        _c("br"),
                        _c("b", [
                          _vm._v(
                            "US $" +
                              _vm._s(_vm._f("currency")(_vm.tokenamt)) +
                              " worth of Impact Tokens."
                          )
                        ]),
                        _vm._v(
                          " You will be billed in the " +
                            _vm._s(_vm.monthly_billing_period) +
                            " of the month."
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.billing_period === "topup"
                    ? _c("span", [
                        _c("p", [
                          _vm._v(
                            "You are about to set up an auto top-up of your Impact Tokens."
                          )
                        ]),
                        _vm._v(" "),
                        (_vm.companySettings &&
                          _vm.companySettings.unallocated <= _vm.topupamt) ||
                        _vm.companySettings.length == 0
                          ? _c("p", [
                              _vm._v("You will be charged "),
                              _c("b", [
                                _vm._v(
                                  "US $" +
                                    _vm._s(_vm._f("currency")(_vm.tokenamt)) +
                                    " today"
                                )
                              ]),
                              _vm._v(" and "),
                              _c("br"),
                              _vm._v("billed again "),
                              _c("b", [
                                _vm._v(
                                  "when your Token balance falls below US $" +
                                    _vm._s(_vm._f("currency")(_vm.topupamt))
                                )
                              ]),
                              _vm._v(".")
                            ])
                          : _c("p", [
                              _vm._v("You will be charged "),
                              _c("b", [
                                _vm._v(
                                  "US $" +
                                    _vm._s(_vm._f("currency")(_vm.tokenamt))
                                )
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _c("b", [
                                _vm._v(
                                  "when your Token balance falls below US $" +
                                    _vm._s(_vm._f("currency")(_vm.topupamt))
                                )
                              ]),
                              _vm._v(".")
                            ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn-sec" }, [
                    _c(
                      "button",
                      {
                        staticClass: "b-btn gray-btn",
                        on: {
                          click: function($event) {
                            return _vm.setBackStep(2)
                          }
                        }
                      },
                      [_vm._v("BACK")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "b-btn red-btn",
                        attrs: { disabled: _vm.startPurchase },
                        on: {
                          click: function($event) {
                            return _vm.purchaseToken()
                          }
                        }
                      },
                      [_vm._v("PROCEED")]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "load" }, [
      _c("hr"),
      _c("hr"),
      _c("hr"),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "loadback" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "small",
        staticStyle: { "font-size": "14px", "margin-top": "15px" }
      },
      [
        _vm._v("By proceeding, you agree to "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.b1g1.org/b1g1-giving-terms-of-service#impact-tokens",
              target: "_blank"
            }
          },
          [_vm._v("B1G1 Giving’s Terms and Conditions")]
        ),
        _vm._v(".")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "font-size": "16px" } }, [
      _vm._v("By proceeding, you agree to "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://www.b1g1.org/b1g1-giving-terms-of-service#impact-tokens",
            target: "_blank"
          }
        },
        [_vm._v("B1G1 Giving’s Terms and Conditions.")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center bee-img" }, [
      _c("img", { attrs: { src: "/static/uploads/bee.png", alt: "bee.png" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f485f07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f485f07","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/token-popup-modal/purchase.vue
// module id = null
// module chunks = 